<template>
    <component
        :blocks-map="blocksMap"
        :elements-map="elementsMap"
        :settings="settings"
        :is="resolveBlock(settings.type)"
    >
        <template v-for="child in children">
            <component
                v-if="resolveElement(child.type)"
                :settings="child"
                :style="childStyle"
                :is="resolveElement(child.type)"
                :parent="parent"
                :key="child.uuid"
            ></component>
            <WidgetBlockContainer
                v-else
                :settings="child"
                :blocks-map="blocksMap"
                :elements-map="elementsMap"
                :style="childStyle"
                :key="child.uuid"
            />
        </template>
    </component>
</template>

<script>
import ViewMixin from "../utils/view-mixin"

export default {
    mixins: [ViewMixin],
    props: {
        blocksMap: {
            type: Object,
            default: () => {}
        },
        elementsMap: {
            type: Object,
            default: () => {}
        },
        settings: {
            type: Object,
            default: () => {}
        },
        parent: {
            type: Object,
            default: () => null
        }
    },
    name: "WidgetBlockContainer",
    data() {
        return {
            BLOCKS: ["CUSTOM", "CTA", "FORM"],
            ELEMENTS: ["BUTTON", "LINK", "TEXT", "INPUT", "IMAGE", "FIELD", "RADIO_FORM_GROUP"]
        }
    },
    computed: {
        childStyle() {
            if (this.isBuilderDev) {
                return
            }
            return {
                pointerEvents: "all"
            }
        },
        children() {
            return this.settings.children.filter(
                child => !child.hasOwnProperty("hidden") || (child.hasOwnProperty("hidden") && !child.hidden)
            )
        }
    },
    methods: {
        elementsFilter(child) {
            return this.ELEMENTS.includes(child.type)
        },
        blocksFilter(child) {
            return this.BLOCKS.includes(child.type)
        },
        resolveBlock(type) {
            if (!this.blocksMap) {
                return
            }
            return this.blocksMap[type]
        },
        resolveElement(type) {
            if (!this.elementsMap) {
                return
            }
            return this.elementsMap[type]
        }
    }
}
</script>
